import { updateInstructor } from '@wix/ambassador-achievements-instructors-v2-instructor/http';
export const updateOnlineProgramsInstructorsImages = async (httpClient, errorHandler, altTextData, instructorsData) => {
  const {
    withErrorHandler
  } = errorHandler;
  if (!instructorsData || !instructorsData.imagesInstructorsMap) {
    return {
      success: false
    };
  }
  const allFailedElements = [];
  const requestsArray = altTextData.map(altTextToUpdate => {
    return getInstructorUpdateRequest(altTextToUpdate, instructorsData);
  });
  const promiseArray = requestsArray.map(async request => {
    return withErrorHandler(async () => {
      httpClient.request(updateInstructor(request));
    }, {
      errorCodesMap: {}
    });
  });
  const results = await Promise.allSettled(promiseArray);
  results.forEach((result, index) => {
    if (result.status === 'rejected') {
      allFailedElements.push(altTextData[index]);
    }
  });
  return {
    failedElements: allFailedElements,
    success: true
  };
};
export const getInstructorUpdateRequest = (altTextData, instructorsData) => {
  const instructorId = instructorsData.imagesInstructorsMap[altTextData.id];
  return {
    actionId: instructorId,
    instructor: {
      id: instructorId,
      photoAltText: altTextData.alt
    }
  };
};
//# sourceMappingURL=update-online-programs-instructors-images.js.map